// LAZY LOADING
var lazyLoadInstance = new LazyLoad({});
lazyLoadInstance.update()


//FORM INPUT
let variantId = document.querySelector('[name=id]') // ID
let productQuantity = document.querySelector('[name=quantity]') //QUANTITY
let productBarcode = document.getElementById('barcode') // _BARCODE

// INPUT 
let quantitySelector = document.querySelectorAll('[data-quantity-selector]')

//TEXT HTML
let sizeText = document.querySelectorAll('[data-product-size]')
let specifics = document.querySelectorAll('[data-specs]')
let productPrice = document.querySelectorAll('[data-product-price]')
let compareProductPrice = document.querySelectorAll('[data-product-compare-price]')
let comparePriceContainer = document.querySelectorAll('.product-compare-price')

// CONTAINERS
let productPriceContainer = document.querySelectorAll('.product-price')

// BUTTONS
let addToCartButton = document.querySelectorAll('[data-add-to-cart]') // ADD TO CART BUTTON
let goToCustomButton = document.querySelectorAll('.product-option-button') //GO TO CUSTOM PRODUCT BUTTON

// MEDIA
let thumbnail = document.querySelectorAll('[data-product-media-thumbnail]')
let floatingFeaturedImage = document.getElementById('floating-buy-image') // FLOATING IMAGE





//FIND VARIANT FROM PRODUCT
function changeVariant(options) {
  console.log(selectedOption)  

  for(let i=0;i < productVariants.length;i++){   
      if(
        options.option1 == productVariants[i].option1 &&
        options.option2 == productVariants[i].option2 &&
        options.option3 == productVariants[i].option3 
      )
        return onSelectChange(productVariants[i]);    
  }
} 



//  CHECK INVENTORY AND CHECK CART 
function getProductQuantityInCart(variant) {
  let cartProductQuantity = 0;

  cartInfo.forEach( item => {
    if(item.variant_id == variant.id)
      cartProductQuantity += item.quantity
  })

  return cartProductQuantity
  

}
// FUNCTIONS
function updateUrl(id) {
  const url = new URL(window.location);
  url.searchParams.set('variant', id);
  window.history.pushState({}, '', url);
}
function updateMainImage(image) {
  if(image.featured_image){
      productFeaturedMedia.parentNode.classList.toggle('active')
      let img1 = new Image();
      img1.src = image.featured_image;
      img1.onload = function() {
        productFeaturedMedia.parentNode.classList.toggle('active')
        productFeaturedMedia.src = image.featured_image
        floatingFeaturedImage.src = image.featured_image
      }
  } 
  else 
    productFeaturedMedia.src = '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_95x95@2x.gif'
}
function updateMedia(color){
  thumbnail.forEach(element => {
    if(element.firstElementChild.alt == color || element.firstElementChild.alt == 'all')
      element.style.display='block'
    else
      element.style.display='none'
  }); 
}
function updatePrice(price){
  productPrice.forEach(el => {
    el.innerHTML = formatter.format(price.price/100)
    el.dataset.productPrice = price.price
  })

}
function updateComparePricing(price){

  if(price.compare_at_price > price.price && price.compare_at_price){
    compareProductPrice.forEach(el => {
      el.innerHTML = formatter.format(price.compare_at_price/100)
      el.dataset.productPrice = price.compare_at_price
      productPriceContainer.forEach(e => {
        e.classList.add('compare')
      })
      
    }) 
  }
    
  else {
    productPriceContainer.forEach(e => {
      e.classList.remove('compare')
    })
  }
  
}
function updateSelectorQuantity(inventory){
  let currentCartInventory = getProductQuantityInCart(inventory)
  let optionMaker='';
  let quantityIn = 1;

  if(inventory.inventory_policy == 'deny') {
    //INVENTORY CHECKER
    quantityIn = inventory.inventory - currentCartInventory 

    for(let i = 1;i <= quantityIn ;i++){
      optionMaker += `<option value='${i}'>${i}</option>`
    }
  
    if(quantityIn <= 0) {
      optionMaker += `<option>1</option>`
      disableAddToCartButton()
    }else {
      enableAddToCartButton()
    }
     quantitySelector.forEach(selector => {
       selector.innerHTML = optionMaker
    })  
  }
  else {
    //INVETORY POLICY CONTINUE TO BUY EVEN IF LESS THAN ZERO 
    for(let i = 1;i <= 10 ;i++){
      optionMaker += `<option value='${i}'>${i}</option>`
    }
     quantitySelector.forEach(selector => {
       selector.innerHTML = optionMaker
    }) 

  }
}

function updateProductBarcode(variant) {
  productBarcode.value = variant.barcode 
}
function enableAddToCartButton() {
  addToCartButton.forEach(button => {
    button.classList.remove('disabled')
    button.removeAttribute('disabled')
  })
  goToCustomButton.forEach(button => {
    button.classList.remove('disabled')
  })
}
function disableAddToCartButton(){
  addToCartButton.forEach(button => {
    button.classList.add('disabled')
    button.setAttribute("disabled", "");
  })
  goToCustomButton.forEach(button => {
    button.classList.add('disabled')
    button.setAttribute("href", "#");
  })
}

//VARIANT SELECTOR CHANGES AFTERMATH
function onSelectChange(variant){
  variantId.value = variant.id      //update FORM input[value='id']
  updateUrl(variant.id)             //update URL
  updateMainImage(variant);         //update main image
  updateMedia(variant.option1);     //update thumbnail
  updateProductBarcode(variant)     //update barcode
  updatePrice(variant)              //update price
  updateComparePricing(variant)     //update compare Pricing
  updateSelectorQuantity(variant)   //update selector quantity
  //updateCustomHref(variant)         //update custom product href
  //updateSpecs(variant)              //update specs text
  //updateAddToCart()               //update JSON DATA
  //updateNotifyMe(variant);
  //updateWishlistData(variant)     //update wishlist data
}
















/******************************************************************************************** */
// UPDATE MAIN IMAGE WHEN THUMBNAIL IS CLICKED  

let thumbnailSelection = document.querySelector('.product-thumbnails')//THUMBNAILS
let productFeaturedMedia = document.querySelector('[data-featured-media]')

if(thumbnailSelection)
thumbnailSelection.addEventListener('click', (e)=>{

  if(e.target.parentElement.dataset.productMediaThumbnail==""){
    productFeaturedMedia.parentNode.classList.toggle('active')
    let img = new Image();
    img.src = e.target.src.replace('100','900');
    
    img.onload = function() {
      productFeaturedMedia.src = e.target.src.replace('100','900')
      productFeaturedMedia.parentNode.classList.toggle('active')
    }; 
  }
})
/******************************************************************************************** */


// SYNC CHANGES IN QUANTITY SELECTOR SP AND PC
function syncSelect(value){  // Change <select> Value
  quantitySelector.forEach(selector =>{
    selector.value = value
  })
}

function multiplyPricing(value){ // Update All Product Price ea. Y1000
  productPrice.forEach(el => {  el.innerHTML = formatter.format((el.dataset.productPrice /100)*value) })
  compareProductPrice.forEach(el => {  el.innerHTML = formatter.format((el.dataset.productComparePrice /100)*value)  })
}



quantitySelector.forEach(selector =>{ 
  selector.addEventListener('change', function(){
    syncSelect(selector.value)
    multiplyPricing(selector.value)
    productQuantity.value = selector.value //change value of input[quantity]
    //updateAddToCart()
  })
})



/****************************************************************************/
// FORM ADD TO CART 

let form = document.getElementById('productForm')
let customProduct = document.getElementById('customProduct')
let mainFeaturedMedia = document.querySelector('.main-featured-media')


addToCartButton.forEach(el => {
  el.addEventListener('click', function(){

    el.setAttribute("disabled", "");
    form.submit()
    mainFeaturedMedia.classList.toggle('active')
  })
})




